import { z } from "zod"

interface InlineEditableBooleanPropertyProps {
   label: string
   value: boolean | null | undefined
   field: string
   editable?: boolean
   schema?: z.ZodType<any>
   onSave?: (field: string, value: boolean) => Promise<void>
}

export function InlineEditableBooleanProperty({
   label,
   value,
   field,
   editable = true,
   onSave,
}: InlineEditableBooleanPropertyProps) {
   const handleChange = async () => {
      if (onSave && editable) {
         await onSave(field, !value)
      }
   }

   return (
      <div className="form-control">
         <label className="label cursor-pointer">
            <span className="label-text">{label}</span>
            <input
               type="checkbox"
               className="toggle toggle-primary"
               checked={value || false}
               onChange={handleChange}
               disabled={!editable}
            />
         </label>
      </div>
   )
}
